export function removeTypeName<Type>(obj: Type): Type {
  if (!obj) {
    return obj;
  }

  for (const prop in obj) {
    if (prop === '__typename') {
      delete obj[prop];
    } else if (typeof obj[prop] === 'object') {
      removeTypeName(obj[prop]);
    }
  }

  return obj;
}
